export default "__VITE_ASSET__Dxi6RYcr__"